import React, { useEffect } from 'react'
// import BannerHome from './BannerTabComponents/BannerHome'
// import BlogMainPage from '../BlogsPreview/Banner/BlogMainPage'
import TabComponent from '../../../Components/TabComponent/TabComponent'
import { Box, Typography } from '@mui/material'
import AllNotification from './NotificationAllTabs/AllNotification'
import JobsNotification from './NotificationAllTabs/JobsNotification'
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../../ReduxStore/actions'
import FeedNotification from './NotificationAllTabs/FeedNotification'
import ConnectionNotification from './NotificationAllTabs/ConnectionNotification'
import ChatNotification from './NotificationAllTabs/ChatNotification'
import InternshipNotification from './NotificationAllTabs/InternshipNotification'
import EventNotification from './NotificationAllTabs/EventNotification'
import MentorRequirementNotification from './NotificationAllTabs/MentorRequirementNotification'
import NewsletterNotification from './NotificationAllTabs/NewsletterNotification'

const NotificationAllmuiTab = () => {

    const dispatch = useDispatch()
    const sessionUserId = sessionStorage.getItem("userId")


    const { markRoomNotificationsAsRead } = useSelector(
        (state) => state?.markRoomNotificationsAsRead
    );

    const { getNotificationCategoryCounts } = useSelector(state => state?.getNotificationCategoryCounts);



    useEffect(() => {

        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getNotificationCategoryCounts/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETNOTIFICATIONCATEGORYCOUNTS(data1));


        }
        fetchData()
    }, [markRoomNotificationsAsRead])



    const tabTitle = ["All", "Feed","Connection","Chat","Internship","Job","Event","Mentor requirement","Newsletter"]


    const tabComponent = [<AllNotification />,<FeedNotification/>,<ConnectionNotification/>,<ChatNotification/>, <InternshipNotification/>,<JobsNotification />,<EventNotification/>,<MentorRequirementNotification/>, <NewsletterNotification/>]


    return (
        <div style={{
            width: "100%"
        }}>
            {/* <TabComponent tabTitle={tabTitle} tabComponent={tabComponent} previewName={BlogMainPage}/> */}
            <TabComponent tabTitle={tabTitle} tabComponent={tabComponent} />

            

            
            
            
        </div>
    )
}

export default NotificationAllmuiTab